import styled from 'styled-components';
import { theme } from '../../styles/theme';

export const Card = styled.div`
  background: ${theme.gradients.card};
  border-radius: ${theme.borderRadius.lg};
  box-shadow: ${theme.shadows.md};
  padding: ${theme.spacing.xl};
  transition: all 0.3s ease;
  border: 1px solid rgba(0, 0, 0, 0.05);
  
  &:hover {
    transform: translateY(-4px);
    box-shadow: ${theme.shadows.xl};
  }
`;

export const CardHeader = styled.div`
  margin-bottom: ${theme.spacing.lg};
`;

export const CardTitle = styled.h3`
  font-size: ${theme.typography.fontSize.xl};
  font-weight: ${theme.typography.fontWeight.semibold};
  color: ${theme.colors.secondary[900]};
  margin: 0 0 ${theme.spacing.sm} 0;
`;

export const CardDescription = styled.p`
  color: ${theme.colors.secondary[600]};
  line-height: 1.6;
  margin: 0;
`;